import { FilterType } from "./useFilterConfig";
import { CombinationsSelections } from "./useSelectionMessage";

/**
 * Hook to handle filter validation logic
 * For combinations: requires at least one activity
 * For other filters: requires at least one selection
 */
export const useFilterValidation = () => {
  const isValid = (
    filterType: FilterType,
    selectedItems: string[],
    combinationsSelections?: CombinationsSelections
  ): boolean => {
    if (filterType === "combinations" && combinationsSelections) {
      // Combinations require at least one activity
      return combinationsSelections.activities.length > 0;
    }
    // Regular filters require at least one selection
    return selectedItems.length > 0;
  };

  const hasAnySelection = (
    filterType: FilterType,
    selectedItems: string[],
    combinationsSelections?: CombinationsSelections
  ): boolean => {
    if (filterType === "combinations" && combinationsSelections) {
      return (
        combinationsSelections.activities.length > 0 ||
        combinationsSelections.locations.length > 0 ||
        combinationsSelections.days.length > 0
      );
    }
    return selectedItems.length > 0;
  };

  return {
    isValid,
    hasAnySelection
  };
};
